import { Component, Input } from '@angular/core';
import { CatalogConfig } from '@app/shared/model/interfaces/catalog';
import { Product } from '@vestiaire/api-sdk-angular';
import { SearchParameters } from '@app/core/search/common';

@Component({
  selector: 'vc-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent {
  @Input()
  state: SearchParameters | null;
  @Input()
  configCatalog: CatalogConfig | null;
  @Input()
  product: Product | null;
}
